// extracted by mini-css-extract-plugin
export default {"loading":"lotteryRecord_loading__eHS6B","pcWrap":"lotteryRecord_pcWrap__qOZR5"};